import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card seq-card seq-map-card h-100" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-5" }
const _hoisted_4 = { class: "fw-bold mb-0 d-flex align-items-center" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Global Partners ")
const _hoisted_7 = { class: "seq-pill-toggle" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-10 text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "row g-6"
}
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "seq-map-card__canvas" }
const _hoisted_12 = {
  ref: "mapContainer",
  class: "seq-map-card__map"
}
const _hoisted_13 = { class: "seq-map-card__total-overlay" }
const _hoisted_14 = { class: "seq-map-card__total-label" }
const _hoisted_15 = { class: "seq-map-card__total-value" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "seq-map-card__stats h-100 d-flex flex-column" }
const _hoisted_18 = { class: "seq-stat-card__label mb-3" }
const _hoisted_19 = { class: "seq-map-card__list flex-grow-1" }
const _hoisted_20 = {
  key: 1,
  class: "seq-map-card__list-dot"
}
const _hoisted_21 = { class: "seq-map-card__list-name" }
const _hoisted_22 = { class: "seq-map-card__list-values" }
const _hoisted_23 = { class: "seq-map-card__list-count" }
const _hoisted_24 = {
  key: 0,
  class: "seq-map-card__list-amount"
}
const _hoisted_25 = {
  key: 0,
  class: "text-muted fs-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DashboardTabNavigator),
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Home/Earth.svg" })
          ]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", {
            type: "button",
            class: ["seq-pill-toggle__btn", { active: _ctx.viewMode === 'team' }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setViewMode('team')))
          }, " Team Expansion ", 2),
          (_ctx.showInsuranceProtection)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: ["seq-pill-toggle__btn", { active: _ctx.viewMode === 'insurance' }],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setViewMode('insurance')))
              }, " Insurance Protection ", 2))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_8, "Loading map..."))
        : (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, null, 512),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalLabel), 1),
                  _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formattedTotal), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.summaryLabel), 1),
                _createVNode("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summaryRows, (row) => {
                    return (_openBlock(), _createBlock("div", {
                      key: row.key,
                      class: "seq-map-card__list-item"
                    }, [
                      (row.iconSrc)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: ["seq-map-card__list-badge seq-map-card__sealpro-bg", row.iconClass],
                            style: {
                    width: _ctx.summaryIconSize + 'px',
                    height: _ctx.summaryIconSize + 'px'
                  }
                          }, [
                            _createVNode("img", {
                              src: row.iconSrc,
                              alt: row.name
                            }, null, 8, ["src", "alt"])
                          ], 6))
                        : (_openBlock(), _createBlock("span", _hoisted_20)),
                      _createVNode("span", _hoisted_21, _toDisplayString(row.name), 1),
                      _createVNode("span", _hoisted_22, [
                        _createVNode("span", _hoisted_23, _toDisplayString(row.count.toLocaleString()), 1),
                        (row.amount !== null)
                          ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.formatAmount(row.amount)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.summaryRows.length === 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.summaryEmptyText), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
    ])
  ]))
}